<template>
	<div>

	</div>
</template>

<script>
	import {Toast, MessageBox } from "mint-ui";
	export default {
		data() {
			return {
				isMenu: 0, //是否是菜单引导进入0：二维码1，菜单引导
			}
		},
		mounted() {
			this.isMenu = this.$route.query.isMenu;
			var openid =  this.$base.getStorage('openid');
			if (!openid) { //静默登录手动登录
				// #ifdef H5
				// this.wechatLogin()
				// #endif
			} else {
				this.gotoUrl();
			}
				console.log('eeee')
		},
		methods: {
			wechatLogin() {
				this.code = this.$base.GetUrlParam('code');
				console.log(this.code)
				if (!this.code) {
					let uri = encodeURIComponent(window.location.href);
					window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.$store.state.user
						.appid + "&redirect_uri=" + uri +
						"&response_type=code&scope=snsapi_base&state=state_base&wechat_redirect&connect_redirect=1#wechat_redirect"
				} else {
					this.userRegister(); //静默注册
				}
			},
			userRegister() { //微信公众号静默登录注册
				var params = {
					code: this.code
				}
				this.$api.userRegister(params).then(res => {
					console.log(res)
					if (res.status == 1) {
						 this.$base.setStorage('openid', res.data.openid)
						this.gotoUrl();
					}
				})
			},
			gotoUrl() {
				if (this.isMenu) { //判断是否是菜单迁入
			
					this.$api.getSameAccountList().then(res => {
						console.log(res.data)
						if (res.status == 1) {
							if (res.data.length == 0) {
								this.$router.push({
									path:'/pages/noAccount/index'
								})
							} else {
									this.$router.push({
									path:'/pages/chooseAccount/index'
								})
							}
						}
					})
				} else { //二维码迁入
					this.$router.push({
									path:'/pages/QcodeMove/index'
								})
				}
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/view/menuIndex/index.vue